import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

class IndexTermHelpRows extends React.Component {

    static propTypes = {
        pguids:            PropTypes.array
    };

    static defaultProps = {
        pguids:            []
    };

    render() {

        let rows = [];
        for (let i = 0; i < this.props.pguids.length; i++) {
            rows.push(
                <div className={"row " + this.props.pguids[i]} key={this.props.pguids[i].pguid}>
                    <div className="row-title">
                        <FormattedMessage id={"pguidTranslation_" + this.props.pguids[i].pguid} />
                    </div>
                    <div className="row-description">
                        <FormattedMessage id={"pguidDescription_" + this.props.pguids[i].pguid} />
                    </div>
                </div>
            );
        }

        return (

            <span>
                {rows}
            </span>
        )
    }

}

export default IndexTermHelpRows;


// WEBPACK FOOTER //
// ./src/scripts/reusable/IndexTermHelp/IndexTermHelp.Rows.jsx